import React from "react";
import { ListItem, ListItemText } from "@mui/material";
import { Droppable } from "react-beautiful-dnd";
import DragItem from "../drag-item";
import { useTheme } from "@mui/material/styles";

const FileListItem = ({ itemObject, index }) => {
  const theme = useTheme();

  return (
    <ListItem key={itemObject.token} sx={{ display: "flex", pr: 0, pl: 0 }} component="div">
      <ListItemText
        sx={{ width: "44%", paddingRight: "1%" }}
        primaryTypographyProps={{ style: { textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" } }}
        primary={itemObject.columnName}
      />
      <Droppable droppableId={itemObject.columnName}>
        {(provided, snapshot) => (
          <div
            style={{
              width: "55%",
              height: "30px",
              backgroundColor: snapshot.isDraggingOver && theme.palette.primary.main,
              border: "1px solid lightgrey"
            }}
            ref={provided.innerRef}
            {...provided.droppableProps}>
            <DragItem itemObject={itemObject} index={index} />
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </ListItem>
  );
};

export default FileListItem;
